/**
 * MarqueePreview Component
 * Real-time preview component for marquee editing
 * Reuses the same animation and styling as MarqueeBanner
 */

import './MarqueePreview.css';

interface MarqueePreviewProps {
  content: string;
  textColor: string;
  bgColor: string;
  bgOpacity: number;
  defaultSpeed?: number;
}

/**
 * Helper function to convert hex color to rgba with opacity
 * Copied from MarqueeBanner for consistency
 */
const bgColorWithOpacity = (color: string, opacity: number): string => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

/**
 * MarqueePreview Component
 * Displays a real-time preview of the marquee with the same animation
 * and styling as the actual MarqueeBanner component
 *
 * Acceptance Criteria:
 * - Preview matches actual display exactly
 * - Real-time updates without delay
 * - Responsive design is correct
 */
const MarqueePreview = ({
  content,
  textColor,
  bgColor,
  bgOpacity,
  defaultSpeed = 15,
}: MarqueePreviewProps) => {
  const displayContent = content || '請輸入文字內容...';

  return (
    <div className="marquee-preview">
      <div
        className="marquee-preview__item"
        style={{
          '--marquee-duration': `${defaultSpeed}s`,
          '--marquee-text-color': textColor,
          '--marquee-bg-color': bgColorWithOpacity(bgColor, bgOpacity),
        } as React.CSSProperties}
      >
        <div className="marquee-preview__track">
          <span className="marquee-preview__content">{displayContent}</span>
          <span className="marquee-preview__content" aria-hidden="true">
            {displayContent}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MarqueePreview;
